import { useState } from 'react'

import { type TextareaSubmitPayload, TextareaWithSubmit } from '@/components/composer/TextareaWithSubmit'
import { Button } from '@/components/ui/button'

interface AskCaiComposerProps {
  onSubmit: (payload: TextareaSubmitPayload) => void
  disabled?: boolean
  placeholder?: string
  composerKey?: number
  handleOpenMessages?: () => void
  /** Grow the box to fill the parent's height instead of sizing to content. */
  fillHeight?: boolean
}

export function AskCaiComposer({
  onSubmit,
  disabled,
  placeholder = 'Ask Cai',
  composerKey,
  handleOpenMessages,
  fillHeight,
}: AskCaiComposerProps) {
  const [value, setValue] = useState('')

  return (
    <TextareaWithSubmit
      key={composerKey}
      fillHeight={fillHeight}
      className={fillHeight ? 'flex-1' : undefined}
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onValueChange={setValue}
      enableUploads
      onSubmitMessage={(payload) => {
        onSubmit(payload)
        setValue('')
      }}
      addonChildren={
        handleOpenMessages ? (
          <Button variant="link" size="sm" onClick={handleOpenMessages}>
            Messages
          </Button>
        ) : undefined
      }
    />
  )
}
